import { createApiAction } from '@app/packages/api/utils'
import type { V3HelpArticleSource } from '@app/packages/api/v3/types/lib'
import type { V3PostHelpAskRequest, V3PostHelpFeedbackRequest } from '@app/packages/api/v3/types/params'
import type {
  V3GetHelpArticleResponse,
  V3GetHelpCategoryResponse,
  V3GetHelpSearchResponse,
  V3GetHelpTopicsResponse,
  V3PostHelpAskResponse,
  V3PostHelpFeedbackResponse,
} from '@app/packages/api/v3/types/responses'

export const getHelpTopics = () =>
  createApiAction('getHelpTopics', dispatch =>
    dispatch<V3GetHelpTopicsResponse>({
      endpoint: '/api/v3/help/topics',
      method: 'GET',
    })
  )

/** 404 when the reader can see none of the category's articles. */
export const getHelpCategory = (slug: string) =>
  createApiAction('getHelpCategory', dispatch =>
    dispatch<V3GetHelpCategoryResponse>({
      endpoint: `/api/v3/help/categories/${encodeURIComponent(slug)}`,
      method: 'GET',
    })
  )

/** Counts a view under `src` on every call. 404 for an article the reader cannot see, private ones included. */
export const getHelpArticle = (slug: string, src: V3HelpArticleSource) =>
  createApiAction('getHelpArticle', dispatch =>
    dispatch<V3GetHelpArticleResponse>({
      endpoint: `/api/v3/help/articles/${encodeURIComponent(slug)}?${new URLSearchParams({ src })}`,
      method: 'GET',
    })
  )

/** 503 when the reranker is down. */
export const getHelpSearch = (q: string) =>
  createApiAction('getHelpSearch', dispatch =>
    dispatch<V3GetHelpSearchResponse>({
      endpoint: `/api/v3/help/search?${new URLSearchParams({ q })}`,
      method: 'GET',
    })
  )

/** Every call is logged as a bot query for the editors. 503 when the reranker is down. */
export const postHelpAsk = (request: V3PostHelpAskRequest) =>
  createApiAction('postHelpAsk', dispatch =>
    dispatch<V3PostHelpAskResponse>({
      endpoint: '/api/v3/help/ask',
      method: 'POST',
      body: JSON.stringify(request),
    })
  )

export const postHelpFeedback = (request: V3PostHelpFeedbackRequest) =>
  createApiAction('postHelpFeedback', dispatch =>
    dispatch<V3PostHelpFeedbackResponse>({
      endpoint: '/api/v3/help/feedback',
      method: 'POST',
      body: JSON.stringify(request),
    })
  )
